<div fxLayout="column" fxLayoutAlign="center none">
  <div class="headerHelp" fxLayout="row" fxLayoutAlign="end none">
    <button
      id="selectHelpButton"
      mat-icon-button
      matTooltip="res.get('OpenHelpLink')"
      aria-label="res.get('SelectHelp')"
      (click)="openHelp()"
    >
      <mat-icon [svgIcon]="res.svgName('Help-Image')" class="helpIcon"></mat-icon>
    </button>
  </div>
  <div class="center">
    <mat-vertical-stepper [linear]="isLinear" #stepper (selectionChange)="onStepChange($event)">
      <ng-template matStepperIcon="edit">
        <mat-icon>done</mat-icon>
      </ng-template>
      <mat-step state="chat" [label]="res.get('WizardWelcome')">
        <div style="display: flex">
          <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 600px">
            <div>
              <h1>{{ res.get('ImportAssets') }}</h1>
            </div>
          </div>
        </div>
        <div fxLayout="row">
          <div fxLayoutAlign="center center">
            <p>{{ res.get('ImportAssetsDescription') }}</p>
          </div>
        </div>
        <hr />
        <div fxLayout="row" style="float: right">
          <div fxFlex="30">
            <button mat-button matStepperNext>
              {{ res.get('ButtonTextContinue') }}
            </button>
          </div>
        </div>
      </mat-step>
      <mat-step #stepAuftrag [label]="res.get('LabelMode')" state="chat">
        <p>{{ res.get('SelectTransformationConfig') }}</p>
        <ng-template #container> </ng-template>
        <hr />
        <div class="step-buttons">
          <button mat-button matStepperPrevious>
            {{ res.get('ButtonTextBack') }}
          </button>
          <button mat-button (click)="moveStep(stepper)">
            {{ res.get('ButtonTextContinue') }}
          </button>
        </div>
      </mat-step>
      <mat-step state="chat">
        <ng-template matStepLabel>{{ res.get('StepperTextCheckData') }}</ng-template>
        <p>{{ firstTitle }}</p>
        @if (display) {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <br />
        <div class="step-buttons">
          <button mat-button class="back-button" (click)="moveBack(stepper)" [disabled]="buttonStatus">
            {{ res.get('ButtonTextBack') }}
          </button>
          <button
            mat-button
            matStepperNext
            (click)="isReadOnly ? null : executeDml()"
            [ngClass]="buttonClass"
            [disabled]="buttonStatus"
          >
            <span>{{ textButton }}</span>
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </div>
</div>
